getNewRatePlanId